import styled from 'styled-components';

export const C = {
    bg: 'linear-gradient(185deg, rgba(15, 17, 23, 0.98) 0%, rgba(10, 11, 15, 0.99) 100%)',
    border: 'rgba(255, 255, 255, 0.05)',
    accent: 'linear-gradient(135deg, #374151, #111827)',
    accentSolid: '#ffffff',
    accentGlow: 'rgba(255, 255, 255, 0.08)',
    textPrimary: '#f8fafc',
    textSecondary: '#94a3b8',
    textMuted: '#64748b',
    hoverBg: 'rgba(255, 255, 255, 0.04)',
    activeBg: 'linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02))',
    soon: '#f59e0b',
    soonBg: 'rgba(245,158,11,0.1)',
};

export const SidebarContainer = styled.nav`
  width: ${p => p.$open ? '272px' : '68px'};
  height: 100dvh;
  background: ${C.bg};
  backdrop-filter: blur(20px);
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1200;
  border-right: 1px solid ${C.border};
  box-shadow: 10px 0 30px rgba(0, 0, 0, 0.25);
  transition: width 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const LogoArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${p => p.$open ? 'space-between' : 'center'};
  padding: ${p => p.$open ? '0 16px 0 20px' : '0'};
  height: 68px;
  border-bottom: 1px solid ${C.border};
  flex-shrink: 0;
  width: 100%;
  position: relative;
  cursor: ${p => p.$open ? 'default' : 'pointer'};
  box-sizing: border-box;
`;

export const SidebarLogo = styled.img`
  width: 108px;
  height: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
  opacity: ${p => p.$open ? 1 : 0};
  max-width: ${p => p.$open ? '108px' : '0'};
  transition: opacity 0.2s, max-width 0.2s;
  flex-shrink: 0;
  display: ${p => p.$open ? 'block' : 'none'};
`;

export const MiniLogo = styled.div`
  width: 32px;
  height: 32px;
  background: ${C.accent};
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  display: ${p => p.$open ? 'none' : 'flex'};
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 14px;
  color: #fff;
  letter-spacing: -0.5px;
  flex-shrink: 0;
  box-shadow: 0 0 12px rgba(255, 255, 255, 0.05);
  transition: opacity 0.22s cubic-bezier(0.4, 0, 0.2, 1), transform 0.22s cubic-bezier(0.4, 0, 0.2, 1);

  ${LogoArea}:hover & {
    opacity: 0;
    transform: scale(0.8);
  }
`;

export const CollapseBtn = styled.button`
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  color: ${C.textSecondary};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;

  /* Closed state styling and positioning */
  position: ${p => p.$open ? 'relative' : 'absolute'};
  top: ${p => p.$open ? 'auto' : '50%'};
  left: ${p => p.$open ? 'auto' : '50%'};
  transform: ${p => p.$open ? 'none' : 'translate(-50%, -50%) scale(0.8)'};
  opacity: ${p => p.$open ? 1 : 0};
  pointer-events: ${p => p.$open ? 'auto' : 'none'};

  ${LogoArea}:hover & {
    opacity: 1;
    pointer-events: auto;
    transform: ${p => p.$open ? 'none' : 'translate(-50%, -50%) scale(1)'};
    background: rgba(255, 255, 255, 0.08);
    color: ${C.textPrimary};
    border-color: rgba(255, 255, 255, 0.2);
  }

  &:hover {
    color: ${C.textPrimary};
    border-color: rgba(255, 255, 255, 0.25);
    background: rgba(255, 255, 255, 0.12) !important;
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.08);
  }
  
  &:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }
`;

export const ScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px 0 8px;

  &::-webkit-scrollbar { width: 3px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.08); border-radius: 2px; }
`;

export const GroupLabel = styled.div`
  font-size: 9px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.25);
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding: ${p => p.$open ? '20px 24px 8px' : '0'};
  text-align: ${p => p.$open ? 'left' : 'center'};
  opacity: ${p => p.$open ? 1 : 0};
  max-height: ${p => p.$open ? '32px' : '0'};
  overflow: hidden;
  transition: all 0.2s ease;
`;

export const NavItem = styled.div`
  margin: 4px 0;
  padding: 0 ${p => p.$open ? '10px' : '0'};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: ${p => p.$active ? '24px' : '0'};
    background: #ffffff;
    border-radius: 0 4px 4px 0;
    transition: height 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 0 8px rgba(255, 255, 255, 0.6);
    z-index: 10;
  }
`;

export const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: ${p => p.$active ? '#ffffff' : '#94a3b8'};
  transition: all 0.22s ease;
  
  svg {
    transition: transform 0.2s ease, stroke 0.2s ease;
  }
`;

export const NavLabel = styled.span`
  color: ${p => p.$active ? '#ffffff' : '#94a3b8'};
  font-size: 14.5px;
  font-weight: ${p => p.$active ? '600' : '500'};
  white-space: nowrap;
  overflow: hidden;
  opacity: ${p => p.$open ? 1 : 0};
  max-width: ${p => p.$open ? '180px' : '0'};
  transition: opacity 0.22s, max-width 0.22s, color 0.18s;
  flex: 1;
  text-align: left;
  letter-spacing: 0.1px;
  display: ${p => p.$open ? 'block' : 'none'};
`;

export const BadgePill = styled.span`
  font-size: 8px;
  font-weight: 700;
  background: ${C.soonBg};
  color: ${C.soon};
  border-radius: 5px;
  padding: 2px 6px;
  letter-spacing: 0.5px;
  white-space: nowrap;
  opacity: ${p => p.$open ? 1 : 0};
  transition: opacity 0.2s;
  display: ${p => p.$open ? 'inline-block' : 'none'};
`;

export const ChevronBtn = styled.span`
  color: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  transition: transform 0.22s ease, color 0.2s ease;
  transform: ${p => p.$expanded ? 'rotate(180deg)' : 'rotate(0)'};
  opacity: ${p => p.$open ? 1 : 0};
  flex-shrink: 0;
`;

export const NavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: ${p => p.$open ? 'flex-start' : 'center'};
  gap: 13px;
  padding: 0 ${p => p.$open ? '12px' : '0'};
  height: 44px;
  width: ${p => p.$open ? '100%' : '44px'};
  background: ${p => p.$active ? C.activeBg : 'transparent'};
  border: 1px solid ${p => p.$active ? 'rgba(255, 255, 255, 0.12)' : 'transparent'};
  border-radius: 10px;
  cursor: ${p => p.$disabled ? 'default' : 'pointer'};
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  opacity: ${p => p.$disabled ? 0.45 : 1};
  box-shadow: ${p => p.$active ? '0 4px 20px rgba(255, 255, 255, 0.02)' : 'none'};

  &:hover {
    background: ${p => p.$disabled ? 'transparent' : p.$active ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.04))' : 'rgba(255, 255, 255, 0.04)'};
    border-color: ${p => p.$disabled ? 'transparent' : p.$active ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.06)'};
    transform: ${p => p.$disabled ? 'none' : p.$open ? 'translateX(3px)' : 'none'};
  }
  
  &:hover ${IconWrap} {
    color: #ffffff;
    svg {
      transform: scale(1.05);
    }
  }

  &:hover ${NavLabel} {
    color: #ffffff;
  }

  &:hover ${ChevronBtn} {
    color: #ffffff;
  }
  
  &:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }

`;

export const SubMenu = styled.div`
  overflow: hidden;
  max-height: ${p => p.$expanded ? `${p.$maxH}px` : '0'};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding-left: ${p => p.$open ? '24px' : '0'};
  margin-left: ${p => p.$open ? '22px' : '0'};
  border-left: ${p => p.$open ? '1px solid rgba(255, 255, 255, 0.05)' : 'none'};
`;

export const SubSection = styled.div`
  margin: 0;
  & + & {
    margin-top: 4px;
    padding-top: 4px;
    border-top: none;
  }
`;

export const SubSectionBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: none;
  border: none;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover { background: rgba(255,255,255,0.03); }
  
  &:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }
`;

export const SubSectionLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.35);
  text-transform: uppercase;
  letter-spacing: 1.2px;
  white-space: nowrap;
`;

export const SubSecChevron = styled.span`
  color: rgba(255,255,255,0.2);
  display: flex;
  align-items: center;
  transition: transform 0.2s;
  transform: ${p => p.$open ? 'rotate(180deg)' : 'rotate(0)'};
`;

export const SubItemsWrap = styled.div`
  overflow: hidden;
  max-height: ${p => p.$open ? '400px' : '0'};
  transition: max-height 0.25s ease;
`;

export const SubItem = styled.button`
  display: flex;
  align-items: center;
  gap: 7px;
  width: 100%;
  background: none;
  border: none;
  padding: 10px 8px 10px 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  white-space: nowrap;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #ffffff;
    opacity: 0;
    transition: all 0.2s ease;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    transform: translateX(4px);
    
    &::before {
      opacity: 1;
      left: 4px;
    }
  }
`;

export const SubLabel = styled.span`
  font-size: 13.5px;
  color: #94a3b8;
  font-weight: 500;
  line-height: 1.4;
  transition: color 0.2s ease;

  button:hover & {
    color: #ffffff;
  }
`;



